/**
 * Shared payment constants — product IDs, plan metadata, pricing.
 * Consumed by the Apple IAP adapter.
 *
 * Premium is a single one-time (non-consumable) unlock — no subscriptions.
 */

export const PLANS = {
  lifetime: {
    id: 'premium_lifetime',
    appleId: 'uk.co.wolftechnologies.pomogrow.premium.lifetime',
    name: 'Premium — Lifetime',
    price: 9.99,
    currency: 'GBP',
    badge: 'Pay Once',
    availableOn: ['web', 'ios'],
  },
};

export const PLAN_IDS = Object.keys(PLANS);

/** Plans available via Apple IAP (have appleId) */
export const APPLE_PLANS = Object.fromEntries(
  Object.entries(PLANS).filter(([, p]) => p.appleId)
);

export const TRIAL_DURATION_DAYS = 7;
